export default function ResultSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 animate-pulse"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="space-y-2">
              <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded w-32" />
              <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-48" />
            </div>
            <div className="h-6 bg-slate-200 dark:bg-slate-700 rounded w-16" />
          </div>
          <div className="space-y-2">
            <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-full" />
            <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-5/6" />
            <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-4/6" />
          </div>
        </div>
      ))}
    </div>
  );
}
